import * as CareerData from './json/career'

export { default as Skills } from './json/skills'
export { default as Specializations } from './json/specializations'
export { default as Training } from './json/training'

export let Career = CareerData;